<template>
  <div class="page-shell page-shell--order-manage" v-permit="'Market.Order.List'">
    <section class="page-shell__content">
      <div class="page-shell__panel page-shell__tabs">
        <div class="page-shell__panel-header">
          <div>
            <div class="page-shell__panel-title">订单列表</div>
            <div class="page-shell__panel-subtitle">
              通过状态标签和搜索条件快速切换订单处理视角。
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="customTabs" type="border-card">
          <el-tab-pane
            v-for="item in tabList"
            :key="item.name"
            :label="item.label"
            :name="item.name"
          >
            <div class="page-shell__tab-pane">
              <public-table
                :loading="Loading"
                :column="column"
                :tableData="orderList"
                :PageInfo="listQuery"
                :searchItems="searchItems"
                :enableSearch="true"
                @handlePaginationChange="handleSearchList"
              >
                <template v-slot:orderType="{ row }">
                  {{ orderTypeName(row.orderType) }}
                </template>
                <template v-slot:appName="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>{{ item.appName }}</div>
                  </div>
                </template>
                <template v-slot:appVersion="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>{{ item.appVersion }}</div>
                  </div>
                </template>
                <template v-slot:createTime="{ row }">
                  {{ row.createTime ? timetrans(row.createTime) : '-' }}
                </template>
                <template v-slot:payTime="{ row }">
                  {{ row.payTime ? timetrans(row.payTime) : '-' }}
                </template>
                <template v-slot:comboPrice="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>{{ item.comboName }}</div>
                  </div>
                </template>
                <template v-slot:totalPrice="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>{{ item.totalPrice }}元</div>
                  </div>
                </template>

                <template v-slot:deliveryMode="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>{{ item.deliveryMode | filterDeliverableType }}</div>
                  </div>
                </template>
                <template v-slot:finalPrice="{ row }">
                  <div>{{ row.finalPrice }}元</div>
                </template>
                <template v-slot:serveriCycle="{ row }">
                  <div v-for="item in row.orderApps" :key="item.appID">
                    <div>
                      {{ item.comboQuantity }}个{{ handleCycle(item.billCycle) }}
                    </div>
                  </div>
                </template>
                <template v-slot:state="{ row }">
                  <span
                    :style="{
                      color: handleOrderState(row.state, 'order')
                    }"
                    >{{ handleOrderState(row.state) }}</span
                  >
                </template>

                <template v-slot:operation="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'Market.Order.Get'"
                    @click="handleEditSort(row)"
                    >详情</el-button
                  >
                  <span v-show="row.state === 'paid'">
                    <el-divider direction="vertical" />
                  </span>
                  <el-button
                    v-permit="'Market.Order.Approve'"
                    v-if="row.state === 'paid'"
                    size="mini"
                    type="text"
                    @click="handleOrderAudit(row)"
                    >审核</el-button
                  >
                  <span v-show="row.state === 'reviewed'">
                    <el-divider direction="vertical" />
                  </span>
                  <el-button
                    v-permit="'Market.Order.Deliver'"
                    v-if="row.state === 'reviewed'"
                    size="mini"
                    type="text"
                    @click="handleOrderDelivery(row)"
                    >交付</el-button
                  >
                </template>
              </public-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
  </div>
</template>
<script>
import { handleOrderState, handleCycle } from '@/utils/dictionary';
import { mapGetters } from 'vuex';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../utils/error';
import { havePerm } from '@/utils/auth';

const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 1,
  query: ''
};

export default {
  name: 'StoreOrderManage',
  computed: {
    ...mapGetters({
      marketID: 'currentMarketID'
    })
  },
  data() {
    const orderTypeOptions = [
      {
        label: '新购',
        value: 'new'
      },
      {
        label: '续费',
        value: 'renew'
      },
      {
        label: '试用',
        value: 'trail'
      },
      {
        label: '升级',
        value: 'upgrade'
      }
    ];
    return {
      timetrans,
      handleOrderState,
      handleCycle,
      activeName:
        this.$route.params.orderState &&
        this.$route.params.orderState !== ':orderState'
          ? this.$route.params.orderState
          : 'all',
      listQuery: defaultListQuery,
      Loading: false,
      orderList: [],
      orderTypeOptions: orderTypeOptions,
      tabList: [
        {
          label: '全部',
          name: 'all'
        },
        {
          label: '待付款',
          name: 'unpaid'
        },
        {
          label: '待审核',
          name: 'paid'
        },
        {
          label: '待交付',
          name: 'reviewed'
        },
        {
          label: '交付中',
          name: 'delivered'
        },
        {
          label: '已完成',
          name: 'fulfill'
        },
        {
          label: '异常订单',
          name: 'closed'
        }
      ],
      column: [
        {
          prop: 'orderID',
          label: '订单号',
          width: '184px'
        },
        {
          prop: 'orderType',
          label: '订单类型',
          width: '80px',
          scopeStatus: true
        },
        {
          prop: 'appName',
          label: '应用',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'appVersion',
          label: '版本',
          scopeStatus: true
        },
        {
          prop: 'comboPrice',
          label: '套餐',
          scopeStatus: true
        },
        {
          prop: 'deliveryMode',
          label: '交付模式',
          width: '78px',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '180px',
          scopeStatus: true
        },
        {
          prop: 'payTime',
          label: '支付时间',
          width: '180px',
          scopeStatus: true
        },
        {
          prop: 'serveriCycle',
          label: '服务周期',
          scopeStatus: true
        },
        {
          prop: 'totalPrice',
          label: '应用费用',
          scopeStatus: true
        },
        {
          prop: 'finalPrice',
          scopeStatus: true,
          label: '应付款'
        },
        {
          prop: 'state',
          label: '交易状态',
          width: '78px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '130px',
          align: 'left',
          scopeStatus: true
        }
      ],
      searchItems: [
        {
          label: '订单号',
          value: '',
          name: 'orderID',
          type: 'input',
          span: 8
        },
        {
          label: '应用名称',
          value: '',
          name: 'appName',
          type: 'input',
          span: 8,
          offset: 1
        },
        {
          label: '订单类型',
          value: '',
          name: 'orderType',
          type: 'select',
          span: 6,
          offset: 1,
          options: orderTypeOptions
        },
        {
          label: '起止时间',
          value: '',
          span: 12,
          name: ['startTime', 'endTime'],
          type: 'timerange'
        }
      ]
    };
  },
  created() {
    if (havePerm('Market.Order.List')) {
      this.fetchStoreOrderList();
    }
  },
  filters: {
    filterDeliverableType(type) {
      return type && type === 'saas' ? 'SaaS' : type === 'paas' ? 'PaaS' : '';
    }
  },

  methods: {
    orderTypeName(t) {
      let typeName = t;
      this.orderTypeOptions.map((item) => {
        if (t == item.value) {
          typeName = item.label;
        }
      });
      return typeName;
    },
    handleEditSort(row) {
      this.$router.push({
        name: 'storeOrderDetails',
        params: { orderID: row.orderID, marketID: row.marketID }
      });
    },
    handleClick(tab, event) {
      this.listQuery.page = 1;
      this.activeName = tab.name;
      this.fetchStoreOrderList();
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery = Object.assign({}, this.listQuery, parameter);
      } else {
        this.listQuery.page = 1;
      }
      this.fetchStoreOrderList();
    },
    fetchStoreOrderList(param) {
      this.Loading = true;
      this.listQuery.marketID = this.marketID;
      const obj = {};
      if (this.activeName !== 'all') {
        obj.state = this.activeName;
      }
      this.$store
        .dispatch('GetStoreOrderList', Object.assign({}, this.listQuery, obj))
        .then((res) => {
          if (res) {
            this.orderList = res.orders;
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    handleOrderDelivery(data) {
      this.handleOperation(
        '是否交付?',
        'PutOrderDelivery',
        data,
        '操作成功，开始交付',
        '交付失败'
      );
    },
    handleOrderAudit(data) {
      this.handleOperation(
        '是否审核该订单?',
        'PutOrderAudit',
        data,
        '审核成功',
        '审核失败'
      );
    },
    handleOperation(title, interfaceName, data, successMessage, errorMessage) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch(interfaceName, data)
          .then(() => {
            this.$message.success(successMessage);
            this.fetchStoreOrderList();
          })
          .catch(() => {
            this.$message.error(errorMessage);
          });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/storeManage/orderManage/index.vue